import { hotel_types, hotel_categories, get_hotel_category } from './hotel_types'
import { amenities, get_amenities } from './amenities'
import { categories, get_categories } from './categories'
import { cots_extrabeds, get_cots_extrabeds } from './cots_extrabeds'
import { languages, get_languages } from './languages'
import { review_score_values } from './review_score_values'
import { extra_charge, get_extra_charge } from './extra_charge'
import { how_to_collect, key_location, get_key_collection } from './key_collection'
import { mealplan, get_mealplan } from './mealplan'
import { beds, get_beds } from './beds'
import { policies, get_policies } from './policies'
import { room_types, get_room_types } from './room_types'
import { accommodation_facilities, get_accommodation_facilities } from './accommodation_facilities'
import { room_facilities, get_room_facilities } from './room_facilities'
import { info_dsa, get_info_dsa } from './info_dsa'


// site resources
export {
  hotel_types,
  hotel_categories,
  amenities,
  categories,
  cots_extrabeds,
  languages,
  review_score_values,
  extra_charge,
  how_to_collect,
  key_location,
  mealplan,
  beds,
  policies,
  room_types,
  accommodation_facilities,
  room_facilities,
  info_dsa,
  get_hotel_category,
  get_amenities,
  get_categories,
  get_cots_extrabeds,
  get_languages,
  get_extra_charge,
  get_key_collection,
  get_mealplan,
  get_beds,
  get_policies,
  get_room_types,
  get_accommodation_facilities,
  get_room_facilities,
  get_info_dsa
}